import React from "react";
import FormDeposit from "../../FormDeposit";
import { useDepositPatientForm } from "../../../../../hooks/useDepositPatientForm";

export default function AddDepositComponents() {
  const {
    formData,
    selectedExistingPatient,
    activeTab,
    loadingSubmit,
    setSelectedExistingPatient,
    setActiveTab,
    handleFormChange,
    handleSubmit,
  } = useDepositPatientForm();

  return (
    <FormDeposit
      // Deposit props
      dataFormDeposit={formData}
      handleChangeDepositForm={handleFormChange}
      // Patient props
      selectedExistingPatient={selectedExistingPatient}
      setSelectedExistingPatient={setSelectedExistingPatient}
      dataFormNew={formData}
      handleChangeForm={handleFormChange}
      onTabChange={(key) => setActiveTab(key)}
      // Form props
      activeTab={activeTab}
      onSubmit={handleSubmit}
      initialValues={formData}
      loading={loadingSubmit}
    />
  );
}
